module.exports = __webpack_public_path__ + "static/img/z10.42d59488.png";